import { render, staticRenderFns } from "./getIntegral.vue?vue&type=template&id=681a017c&scoped=true"
import script from "./getIntegral.vue?vue&type=script&lang=js"
export * from "./getIntegral.vue?vue&type=script&lang=js"
import style0 from "./getIntegral.vue?vue&type=style&index=0&id=681a017c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a017c",
  null
  
)

export default component.exports